export default String.raw`
{% include 'partials/product/comparison/comparison.html' -%}
`